import { testimonials } from "../content/site";

export default function Testimonials() {
  return (
    <section className="band band-dark" aria-labelledby="t-heading">
      <div className="wrap">
        <h2 id="t-heading" className="section-title center">
          in their <strong>words</strong>
        </h2>
        <ul className="testimonials" role="list">
          {testimonials.map((t) => (
            <li key={t.name} className="testimonial">
              <blockquote>“{t.quote}”</blockquote>
              <div className="who">
                <img src={t.photo} alt="" width="56" height="56" loading="lazy" />
                <div>
                  <strong>{t.name}</strong>
                  <span>{t.role}</span>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
